module.exports = __webpack_public_path__ + "img/tractor-dozer.5f18853.png";